/* eslint-disable no-alert */
/* global application */

import { APIHOST } from '../../config';

const $submitAvailabilityBtn = $('.btn-submit-avaiability');

function checkTimeSlots(digestKey) {
  if (digestKey) {
    const timeslotsUrl = `${APIHOST}/v1/meetings/${digestKey}/time_slots`;
    return axios.get(timeslotsUrl).then((res) => res.data.time_slots || []);
  }
  return undefined;
}

if (!window.checkTimeSlots) {
  window.checkTimeSlots = checkTimeSlots;
}

function sendDirectMessage(positionApplicationId, content) {
  const directMessageUrl = `${APIHOST}/v1/direct_messages`;
  return axios.post(directMessageUrl, {
    direct_message: {
      position_application_id: positionApplicationId,
      content,
    },
  });
}

$(() => {
  if (typeof application !== 'undefined' && application.applicant_has_sent_interview_availability === 1) {
    $('.organization-position-apply-no-timeslots .form-wrapper').addClass('dn');
    $('.organization-position-apply-no-timeslots .submit-response').removeClass(
      'dn',
    );
  }
});

$submitAvailabilityBtn.click((e) => {
  const content = $('#interview-availability')[0] && $('#interview-availability')[0].value;
  const positionApplicationId = $('body').attr('data-application-id') || (application && application.id);
  if (!content) {
    alert('Please input the message first');
  } else if (positionApplicationId) {
    sendDirectMessage(parseInt(positionApplicationId, 10), content)
      .then(() => {
        $('.organization-position-apply-no-timeslots .form-wrapper').addClass(
          'dn',
        );
        $(
          '.organization-position-apply-no-timeslots .submit-response',
        ).removeClass('dn');
      })
      .catch((error) => {
        const { response } = error;
        const { message } = response.data;
        alert(message || '');
      });
  }
});
